export class LocaleSwitcherController {
    constructor(localeService){
        'ngInject'

        this.locales = []
        this.selectedLocale = "en_US"
        this.localeService = localeService
        localeService.retrieveLocales()
            .then(locales => {
                this.locales = locales;
            });

        localeService.retrieveCurrentLocale()
            .then(selectedLocale => {
                if (selectedLocale) {
                    this.selectedLocale = selectedLocale.localeID;
                }
            });
    }

    setCurrentLocale(locale) {
        return this.localeService.setCurrentLocale(locale.localeID)
            .then(() => {
                this.selectedLocale = locale.localeID;
            })
            .catch(ex => {
                alert("Changing the country failed. " + (ex.message || ex.statusText || ex));
            });
    }
}
